<div class="z-90">
  <div class="flex flex-col items-center">
    <img class="max-w-40" [src]="(isWhiteLabel$ | async) ? wlLoadingLogo : tilledLoadingLogo" />
    <div class="max-w-120 pt-4 text-center">
      <tilled-heading-h4>We are preparing your agreement for signature.</tilled-heading-h4>
      <tilled-heading-h4>This may take a few moments.</tilled-heading-h4>
    </div>
  </div>
</div>
